import { render } from "./Step3PatientInformation.vue?vue&type=template&id=334024ba"
import script from "./Step3PatientInformation.vue?vue&type=script&lang=js"
export * from "./Step3PatientInformation.vue?vue&type=script&lang=js"

import "./Step3PatientInformation.vue?vue&type=style&index=0&id=334024ba&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__